/**
 * Добавленные допродажи внутри карточки машины — МСК Газобетон.
 *
 * Второго списка товаров здесь не заводится: позиции берутся из того же
 * offer.materials, а индекс каждой позиции сохраняется, потому что именно им
 * работают существующие обработчики `updateAdditionalMaterialQuantity`
 * и `removeMaterial`.
 *
 * Своей арифметики нет: количество, цена и сумма приходят из позиции,
 * паллетоместа — общей функцией `getUpsellPalletPlaces`, той же, которой
 * пользуются блоки КП и модель загрузки машин.
 */

import { getUpsellPalletPlaces } from './buildGazCommercialProposalBlocks.js';

/**
 * @param {object}  params
 * @param {object}  params.offer                — выбранное предложение
 * @param {boolean} params.isMskGazobetonScope  — признак области, приходит готовым
 * @returns {Array<{index:number,name:string,quantity:number,unit:string,
 *                  palletPlaces:number|null,pricePerOne:number,sum:number}>}
 *   Вне области — всегда пустой список: там допродажи показываются как в 5442898.
 */
export const buildGazProposalUpsells = ({ offer, isMskGazobetonScope } = {}) => {
  if (!isMskGazobetonScope) {
    return [];
  }

  const materials = Array.isArray(offer?.materials) ? offer.materials : [];
  const list = [];

  materials.forEach((material, index) => {
    if (!material?.isFromInsulationFriends) {
      return;
    }
    list.push({
      // Индекс в offer.materials — адрес позиции для существующих обработчиков.
      index,
      name: String(material?.name || '').trim(),
      quantity: Number(material?.quantity) || 0,
      unit: String(material?.unit || '').trim(),
      // null — норма поддона не заведена. Придумывать её нельзя, интерфейс
      // покажет прочерк.
      palletPlaces: getUpsellPalletPlaces(material),
      pricePerOne: Number(material?.pricePerOne) || 0,
      sum: Number(material?.sum) || 0,
      // Наличие показывается, только если оно пришло вместе с позицией.
      stockNote: material?.gazStockNote || null,
    });
  });

  return list;
};

export default buildGazProposalUpsells;
